import AdminLayout from "@/components/feature/AdminLayout";
import PaymentsKpis from "./components/PaymentsKpis";
import PaymentsRevenueChart from "./components/RevenueChart";
import MethodBreakdown from "./components/MethodBreakdown";
import ArAging from "./components/ArAging";
import StatusMix from "./components/StatusMix";
import TransactionsTable from "./components/TransactionsTable";

export default function PaymentsPage() {
  return (
    <AdminLayout>
      <div className="px-4 md:px-8 py-6 md:py-8 max-w-[1600px] mx-auto space-y-6">
        {/* Header */}
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-4">
          <div>
            <div className="flex items-center gap-2 text-xs text-ink-500 mb-2">
              <span>Business</span>
              <i className="ri-arrow-right-s-line"></i>
              <span className="text-ink-900 font-semibold">Payments</span>
            </div>
            <h1 className="font-display text-3xl md:text-4xl font-bold text-ink-900 leading-tight">
              Payments & Financial Reports
            </h1>
            <p className="text-sm text-ink-500 mt-1.5 max-w-xl">
              Every deposit, balance, and refund — with revenue trends and payment method
              insights at a glance.
            </p>
          </div>
          <div className="flex items-center gap-2">
            <button className="inline-flex items-center gap-2 px-4 py-2.5 rounded-md text-sm font-semibold border border-ink-200 bg-white text-ink-700 hover:bg-cream-100 cursor-pointer whitespace-nowrap">
              <i className="ri-file-chart-line"></i>
              Reports
            </button>
            <button className="inline-flex items-center gap-2 px-4 py-2.5 rounded-md text-sm font-semibold bg-brand-500 hover:bg-brand-600 text-white cursor-pointer whitespace-nowrap">
              <i className="ri-bank-card-line"></i>
              Create Invoice
            </button>
          </div>
        </div>

        {/* KPI strip */}
        <PaymentsKpis />

        {/* Revenue trend + Method breakdown */}
        <section className="grid grid-cols-1 lg:grid-cols-3 gap-4 md:gap-5">
          <div className="lg:col-span-2">
            <PaymentsRevenueChart />
          </div>
          <div>
            <MethodBreakdown />
          </div>
        </section>

        {/* AR aging */}
        <ArAging />

        {/* Status mix + daily volume */}
        <StatusMix />

        {/* Transactions */}
        <TransactionsTable />
      </div>
    </AdminLayout>
  );
}